/** Prefix `redux-persist` gives every key it writes. */
const PERSIST_PREFIX = 'persist:';

/**
 * Removes every `redux-persist` key from `localStorage`, synchronously.
 *
 * The last step of signing out, after `pause`, `flush` and `purge`. Those three
 * should be enough, but they run through the library's own queue and the page
 * is replaced right afterwards; this leaves nothing to a race. Reading the keys
 * first and deleting after avoids mutating the store while iterating it.
 *
 * Wrapped because `localStorage` throws in a private window with site data
 * blocked, and failing to tidy up must not keep somebody signed in.
 */
export const clearPersistedKeys = () => {
  try {
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(PERSIST_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => window.localStorage.removeItem(key));
  } catch (error) {
    console.error('No se pudo limpiar el almacenamiento local:', error);
  }
};
